import { watch, computed, ComputedRef, reactive, ref, Ref } from 'vue';

import ICombinedFilterComponent from '@Components/CombinedFilter/ICombinedFilterComponent';


export interface CombinedFilterSetupResult {

    isFilterVisible: Ref<boolean>;

    onSearchBarAction: (targetArea: string | undefined) => void;
    onHideFilter: () => void;


}


export function setupCombinedFilter(filterInstance: Ref<ICombinedFilterComponent | null>): CombinedFilterSetupResult {
    //performs setup for the two components and their interaction. that is what the ICombinedFilterComponent is for,
    // if not null, it will be used to trigger the correct area from the bar click.


    // note that depending on mobile or desktop, we might
    // actually want to have a different default value.
    // e.g. for mobile hidden, but for large desktop, (where it collapses left/right)
    // we might want to have it visible.

    // todo: we have done something in BHVK to do some default setup based on initial
    // screen size. We might want to do something similar here. is not perfect,
    // but works for most default cases.
    const isMapFilterVisible = ref(false);

    // handles clicks from the search bar action. initially
    // only opens the bar, but with parameters we can also determine
    // a specific action.
    const onSearchBarAction = (targetArea: string | undefined) => {


        filterInstance.value?.onFocusArea(targetArea);
        isMapFilterVisible.value = !isMapFilterVisible.value;


    };

    const onHideFilter = () => {


        isMapFilterVisible.value = false;
    };

    return {

        isFilterVisible: isMapFilterVisible,
        onSearchBarAction,
        onHideFilter
    };

}